<template>
	<div class="nav-link-wrapper alerts">
		<router-link v-if="selectedAccount" class="nav-link" :to="{ name: 'AlertList', params: { user_uid: selectedAccount } }">
			<svgicon name="alert" :fill="false"/>
			<span>{{ $t('base.general.alerts') }}</span>
			<div v-if="alerts.data.length" class="alerts-number">{{ alerts.data.length }}</div>
		</router-link>
	</div>
</template>

<script>
export default {
	computed: {
		selectedAccount () {
			return this.$store.state.user.selectedAccount
		},
		alerts () {
			return this.$store.getters.getAccountAlertsUnread(this.selectedAccount)
		}
	}
}
</script>



// WEBPACK FOOTER //
// src/components/navigation/NavigationAlerts.vue